const actionPrefix = (action) => `Analytics/${action}`;

export const RESTORE_ANALYTICS = actionPrefix`RESTORE_ANALYTICS`;
export const restoreAnalytics = (metadata) => ({
  type: RESTORE_ANALYTICS,
  payload: metadata,
});
